export var PRODUCTION_SUBSCRIPTIONS_IDS = {
  Standard: 'X5PJHZ1FRBND4',
  Professional: 'QBX00V8SPAZRA'
};
export var STAGING_SUBSCRIPTIONS_IDS = {
  Standard: '5NJMY2B8GWHD2',
  Professional: 'VTXMV7109M026'
};